module.exports = __webpack_public_path__ + "img/777.c24a6fcf.png";